'use client';
import './style.sass';
import '../reusable-components/style.sass';

import React from 'react';

import { listPath, listTitle } from './constants';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import Review from '../reusable-components/layouts-components__common-cases/review';
import Complex from '../reusable-components/layouts-components__rukami/complex';
import PortfolioGallery from '../reusable-components/layouts-components__rukami/portfolio-gallery';
import Process from '../reusable-components/layouts-components__rukami/process';
import Results from '../reusable-components/layouts-components__rukami/results';
import Tasks from '../reusable-components/layouts-components__rukami/tasks';
import Team from '../reusable-components/layouts-components__rukami/team';
import TitleCase from '../../case-components/title-case';
import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const reviewRukami = {
    reviewText:
        'Профессионализм команды позволил проекту Rukami в&nbsp;кратчайшие сроки организовать и&nbsp;провести в&nbsp;онлайне мероприятие с&nbsp;участием более 30&nbsp;000 зарегистрированных пользователей. Были воплощены в&nbsp;жизнь наши самые невероятные идеи по&nbsp;вовлечению и&nbsp;удержанию молодежи на&nbsp;портале во&nbsp;время мероприятия, в&nbsp;том числе реализован сложный дизайн, созданный Студией Артемия Лебедева, разработана система регистрации и&nbsp;учета активностей посетителей и&nbsp;многое другое. Вместе нам удалось сделать онлайн-мероприятие интересным, вовлекающим и&nbsp;ярким',
    reviewAuthors: [
        {
            title: 'Наталья Смелкова',
            subtitle: 'Руководитель проекта Rukami',
        },
        {
            title: 'Мария Тучина',
            subtitle: 'Руководитель фестиваля Rukami',
        },
    ],
};

const awards = [
    {
        id: '1',
        img: '/images/svg/rukami/awards/red-dot.svg',
        link: 'https://www.red-dot.org/',
    },
    {
        id: '2',
        img: '/images/svg/rukami/awards/gold-site.svg',
        link: 'http://2020.goldensite.ru/results/',
    },
    {
        id: '3',
        img: '/images/svg/rukami/awards/event-of-the-year.png',
        link: 'https://www.facebook.com/eventpremia/',
    },
    {
        id: '4',
        img: '/images/svg/rukami/awards/silver-archer.png',
        link: 'http://www.luchnik.ru/news/10162/',
    },
];

const Rukami = () => {
    const casePathname = '/cases/development/rukami';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section className="rukami">
            <TitleCase
                listTitle={listTitle}
                img="/images/pic/rukami/rukamiBanner.jpg"
                caseName="rukami-title"
                listPath={listPath}
            />
            <FullWrapper isMargin={0}>
                <div className="rukami-title__block">
                    <div className="rukami-title__block-left">
                        <CommonSmallTitle>
                            RUKAMI&nbsp;&mdash; это некоммерческий фестиваль идей и&nbsp;технологий.{' '}
                        </CommonSmallTitle>
                        <CommonSmallText className="rukami__paragraph">
                            В&nbsp;нем участвуют школьники и&nbsp;студенты, которые занимаются
                            в&nbsp;кружках технического творчества. Проект объединяет тысячи юных
                            мейкеров со&nbsp;всех уголков России и&nbsp;энтузиастов кружкового
                            движения из&nbsp;других стран.
                        </CommonSmallText>
                    </div>
                    <div className="rukami-title__block-right">
                        <div className="rukami-title__block-subtitle">Завоеванные премии</div>
                        <div className="rukami-title__block-awards">
                            {awards.map(item => (
                                <a
                                    key={item.id}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    <img
                                        src={item.img}
                                        alt="awards"
                                        className="rukami-title__block-icon"
                                    />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>

            <Tasks />

            <Complex />

            <Process />

            <PortfolioGallery />

            <Results />

            <Team />

            <Review Review={reviewRukami} />

            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>

            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default Rukami;
